import { useContext } from 'react';

import { AppContextProps, AppStateContext } from '../providers/AppStateContext';

export const useAppState = (): AppContextProps => {
  const ctx = useContext(AppStateContext);

  if (!ctx) {
    throw new Error('Please configure AppStateContext before using "useAppState()"');
  }

  return ctx;
};
